/* eslint-disable grammar/no-unit-literal --
   This is the user-preference *picker* catalog, not a figure render. The unit
   strings here are the selectable display-unit options the person chooses for
   themselves; figures are still rendered through the figure object (Metric/
   StateWord), which is what grammar/no-unit-literal protects. Same reasoning the
   config narrows for fixture/stub data. */
import type { SelectOption } from "@solarkey/ui";

/* ── Display section catalogs ─────────────────────────────────────── */

export const THEME_OPTIONS: SelectOption[] = [
  { key: "light", label: "Light" },
  { key: "dark", label: "Dark" },
  { key: "system", label: "Follow device" },
];

export const DENSITY_OPTIONS: SelectOption[] = [
  { key: "comfortable", label: "Comfortable" },
  { key: "compact", label: "Compact" },
];

export const LANGUAGES: SelectOption[] = [
  { key: "en-GB", label: "English (UK)" },
  { key: "en-US", label: "English (US)" },
  { key: "en-IN", label: "English (India)" },
  { key: "hi-IN", label: "हिन्दी (भारत)" },
  { key: "mr-IN", label: "मराठी (भारत)" },
];

export const LOCALES: SelectOption[] = [
  { key: "en-IN", label: "en-IN · lakh, crore" },
  { key: "en-GB", label: "en-GB · thousand, million" },
  { key: "en-US", label: "en-US · thousand, million" },
  { key: "hi-IN", label: "hi-IN · लाख, करोड़" },
  { key: "mr-IN", label: "mr-IN · लाख, कोटी" },
];

export const TIMEZONE_OPTIONS: SelectOption[] = [
  { key: "site", label: "Site time" },
  { key: "utc", label: "UTC" },
  { key: "local", label: "Browser local" },
];

export const DISPLAY_UNIT_PRESETS: SelectOption[] = [
  { key: "kw-mwh", label: "kW, MWh, W/m², °C" },
  { key: "kw-kwh", label: "kW, kWh, W/m², °C" },
  { key: "mw-mwh", label: "MW, MWh, W/m², °C" },
];

export const MOTION_OPTIONS: SelectOption[] = [
  { key: "follow", label: "Follow device" },
  { key: "reduce", label: "Reduce" },
];

export const CONTRAST_OPTIONS: SelectOption[] = [
  { key: "off", label: "Off" },
  { key: "on", label: "On" },
];

/* ── Notification class defaults (wireframe A6 §2) ────────────────── */

export type NotifState = "on" | "off" | "digest";

export interface NotifRow {
  key: string;
  label: string;
  inApp: NotifState;
  email: NotifState;
  push: NotifState;
  timing: string;
}

export const NOTIFICATION_DEFAULTS: NotifRow[] = [
  { key: "approvals",  label: "Approvals waiting on me",        inApp: "on", email: "on",     push: "on",  timing: "immediate" },
  { key: "datapath",   label: "Data path down",                 inApp: "on", email: "on",     push: "on",  timing: "immediate, after 15 min" },
  { key: "critical",   label: "Critical device alerts",         inApp: "on", email: "off",    push: "on",  timing: "immediate" },
  { key: "findings",   label: "Findings and verified closures", inApp: "on", email: "digest", push: "off", timing: "07:00 site time" },
  { key: "reports",    label: "Reports ready",                  inApp: "on", email: "on",     push: "off", timing: "on generation" },
  { key: "everything", label: "Everything else",                inApp: "on", email: "off",    push: "off", timing: "daily digest" },
];

/* ── Defaults ─────────────────────────────────────────────────────── */

export const DEFAULTS = {
  locale: LOCALES[0]!.key,
  language: LANGUAGES[0]!.key,
  timezone: TIMEZONE_OPTIONS[0]!.key,
  units: DISPLAY_UNIT_PRESETS[0]!.key,
  motion: MOTION_OPTIONS[0]!.key,
  contrast: CONTRAST_OPTIONS[0]!.key,
};
